<template>
  <div class="contents" v-if="opened">
    <div class="scroll-height">
      <template>
        <list-option
          v-for="type in uniqueTypesList"
          v-bind:key="type.id"
          :main-text="type.name"
          :disabled="!(type.isValid && type.selectable)"
          v-on:selected="selectType(type)"
          v-on:unselected="unselectType(type)">
        </list-option>
      </template>
    </div>
    <div class="width-100 fixed-bottom flex-v-center flex-justify-right padding-v-half clickable" v-on:click="submit()">
      <span class="font-14 padding-r-half">Continue</span>
      <svg class="padding-r-1-em" width="8px" height="15px">
        <path d="M0 0 L8 7.5 L0 15 L0 13.5 L6.5 7.5 L0 1.5"></path>
      </svg>
    </div>
  </div>
</template>

<script>
import ListOption from './listOption'

export default {
  name: 'linkedTypeStage',
  props: [
    'type',
    'opened'
  ],
  data () {
    return {
      selectedTypes: [],
      availableTypes: []
    }
  },
  components: {
    ListOption
  },
  methods: {
    selectType (type) {
      if (type.isValid) {
        this.selectedTypes.push(type)
      }
      this.updateAvailableLinkedTypesValidity()
    },

    unselectType (type) {
      if (type.isValid) {
        this.selectedTypes = this.selectedTypes.filter(function (item) {
          return item.id !== type.id
        })
      }
      this.updateAvailableLinkedTypesValidity()
    },

    updateAvailableLinkedTypesValidity () {
      // Retrieve remaining valid combinations given current selection
      let remainingValidCombinations = this.validTypeCombinations.filter(function (combination) {
        let valid = true
        this.selectedTypes.forEach((selectedType) => {
          valid = valid && combination.includes(selectedType.id)
        })
        return valid
      }, this)

      // Reduce to unique remaining valid types
      const remainingValidTypes = this.reduceToUniqueValues(remainingValidCombinations)

      // Update validity of available types
      this.availableTypes = this.availableTypes.map(typeList => {
        return typeList.map(type => {
          type.selectable = remainingValidTypes.includes(type.id)
          return type
        })
      })
    },

    reduceToUniqueValues (typeList) {
      let uniqueTypes = []

      typeList.forEach(function (typeList) {
        typeList.forEach(function (type) {
          if (!uniqueTypes.includes(type)) {
            uniqueTypes.push(type)
          }
        })
      })

      return uniqueTypes
    },

    submit () {
      this.$emit('input', this.selectedTypes)
    }
  },
  computed: {
    uniqueTypesList: function () {
      if (!this.availableTypes.length) {
        return []
      }

      return this.reduceToUniqueValues(this.availableTypes)
    },

    validTypeCombinations: function () {
      let validCombinations = []

      if (!this.availableTypes.length) {
        return validCombinations
      }

      this.availableTypes.forEach(function (typeList) {
        let typeCombo = []
        typeList.forEach(function (type) {
          typeCombo.push(type.id)
        })
        validCombinations.push(typeCombo)
      })

      return validCombinations
    }
  },
  watch: {
    type: function () {
      if (this.type !== null && this.type.linkedTypes !== null) {
        this.availableTypes = this.type.linkedTypes
        this.selectedTypes = []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// linkedTypeStage.vue?119e7e51